import { Method } from '../../data/DataUtils.js';
import * as DataUtils from '../../data/DataUtils.js';
import * as DTOs from '../DTOs/TorneoParticipantesDTOs.js';

export const DeleteItem = async (idPadre, idItem) => {
  return await DataUtils.SaveObject(
    Method.DELETE,
    'torneos/' + idPadre + '/participantes/' + idItem,
    null
  );
};

export const GetItem = async (idPadre, idItem) => {
  return DataUtils.FetchObject('torneos/' + idPadre + '/participantes/' + idItem);
};

export const GetListaItems = async (idPadre) => {
  const lista = await DataUtils.FetchLista('torneos/' + idPadre + '/participantes');
  return lista.map((item) => ({
    ...item,
    organizador: item.esOrganizador ?? item.organizador ?? false,
  }));
};

export const PostItem = async (idPadre, datosItem) => {
  const idCreado = await DataUtils.SaveObject(
    Method.POST,
    'torneos/' + idPadre + '/participantes',
    DTOs.saveItem(datosItem)
  );
  // SaveObject devuelve el ID directamente (del header Location o de environment.data)
  return idCreado;
};

export const PutItem = async (idPadre, datosItem) => {
  await DataUtils.SaveObject(
    Method.PUT,
    'torneos/' + idPadre + '/participantes/' + datosItem.id,
    DTOs.saveItem(datosItem)
  );
  return datosItem.id;
};
